import React from 'react';
import { Tooltip, withStyles } from '@material-ui/core';

interface CustomTooltipProps {
  title: string;
  children: React.ReactElement;
  themeMode: 'light' | 'dark';
  disabled: boolean;
}

const StyledTooltip = withStyles({
  tooltip: {
    fontSize: '1rem',
    padding: '10px 14px',
    backgroundColor: (props: any) =>
      props.themeMode === 'light' ? '#6C7293' : '#FFFFFF',
    color: (props: any) => (props.themeMode === 'light' ? '#FFF' : '#6C7293'),
  },
  arrow: {
    color: (props: any) =>
      props.themeMode === 'light' ? '#6C7293' : '#FFFFFF',
  },
})(({ ...props }: any) => <Tooltip {...props} arrow placement="bottom-end" />);

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  title,
  disabled,
  children,
  themeMode,
}) => {
  return (
    <StyledTooltip
      title={title}
      themeMode={themeMode}
      disableHoverListener={disabled}
      disableFocusListener={disabled}
      disableTouchListener={disabled}
    >
      {children}
    </StyledTooltip>
  );
};

export default CustomTooltip;
